<script lang="ts">
	import { browser } from '$app/environment';
	import { page } from '$app/stores';
	import { locale, localizeHref } from './locale';
	const href: string = $derived(
		$page.url.pathname + (browser ? $page.url.search + $page.url.hash : '')
	);
</script>

<nav
	aria-label="Language / 言語"
	data-sveltekit-preload-code="eager"
	data-sveltekit-preload-data="hover"
	class="language-selector grid shrink-0 grid-cols-[auto_auto_auto] items-center gap-[3px] whitespace-nowrap text-xs text-zinc-600 dark:text-zinc-400"
>
	<a
		lang="en"
		hreflang="en"
		aria-current={$locale === 'en' ? 'page' : undefined}
		data-label="English"
		class="rounded px-1 py-1 hover:underline aria-[current=page]:font-semibold"
		href={localizeHref('en', href)}>English</a
	>
	<span aria-hidden="true">/</span>
	<a
		lang="ja"
		hreflang="ja"
		aria-current={$locale === 'ja' ? 'page' : undefined}
		data-label="日本語"
		class="rounded px-1 py-1 hover:underline aria-[current=page]:font-semibold"
		href={localizeHref('ja', href)}>日本語</a
	>
</nav>

<style>
	/* Each slot reserves its label's semibold width so the active weight never shifts the picker. */
	.language-selector a::after {
		content: attr(data-label);
		display: block;
		height: 0;
		overflow: hidden;
		font-weight: 600;
		visibility: hidden;
	}
</style>
